/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext } from 'react';
import Switch from 'react-switch';
import { ThemeContext } from 'styled-components';
import { Link } from 'react-router-dom';
import { ContainerAbout, SubtitleContainer, SubTitle, ContainerTech, BoxTech, TextTech } from './styles';

import TechlogiesData from '../../techlogies';

import photo from '../../assets/photo.png';

import { FiArrowRight } from "react-icons/fi";
import { ImRadioChecked } from "react-icons/im";
import { 
    FaReact, IoLogoJavascript, SiTypescript, SiPhp, TbBrandNextjs, FaNodeJs, FaPython, 
    GrMysql, FaGitAlt, FaGithub, FaAngular, FaSass, FaHtml5, FaCss3Alt, SiPrisma, FaLaravel, 
    FaJava, FaBootstrap, SiPostgresql, SiSpringboot, SiInsomnia, SiDocker, SiVercel, SiChakraui, SiC
} from "../../components/Technologies/imports";

interface Props {
    toggleTheme(): void;
}

const Technologies: React.FC<Props> = ({ toggleTheme }) => {
    const { colors, title } = useContext(ThemeContext);

    return (
        <ContainerAbout>
            <SubtitleContainer>
                <SubTitle>
                    Linguagens e tecnologias
                </SubTitle>
            </SubtitleContainer>
            <ContainerTech>
                {TechlogiesData.map((item)=> {
                    const { id, name, icon } = item;
                    return (
                        <BoxTech key={id}>
                            {name === 'Insomnia' && <SiInsomnia color="#37D892" size={30}/>}
                            {name === 'Springboot' && <SiSpringboot color="#37D892" size={30}/>}
                            {name === 'Postgresql' && <SiPostgresql color="#37D892" size={30}/>}
                            {name === 'Bootstrap' && <FaBootstrap color="#37D892" size={30}/>}
                            {name === 'Java' && <FaJava color="#37D892" size={30}/>}
                            {name === 'JavaScript' && <IoLogoJavascript color="#37D892" size={30}/>}
                            {name === 'React JS' && <FaReact color="#37D892" size={30}/>}
                            {name === 'TypeScript' && <SiTypescript color="#37D892" size={30}/>}
                            {name === 'NextJs' && <TbBrandNextjs color="#37D892" size={30}/>}
                            {name === 'NodeJs' && <FaNodeJs color="#37D892" size={30}/>}
                            {name === 'MySQL' && <GrMysql color="#37D892" size={30}/>}
                            {name === 'Python' && <FaPython color="#37D892" size={30}/>}
                            {name === 'Git' && <FaGitAlt color="#37D892" size={30}/>}
                            {name === 'GitHub' && <FaGithub color="#37D892" size={30}/>}
                            {name === 'Angular' && <FaAngular color="#37D892" size={30}/>}
                            {name === 'Sass' && <FaSass color="#37D892" size={30}/>}
                            {name === 'Html' && <FaHtml5 color="#37D892" size={30}/>}
                            {name === 'Css' && <FaCss3Alt color="#37D892" size={30}/>}
                            {name === 'Prisma' && <SiPrisma color="#37D892" size={30}/>}
                            {name === 'Laravel' && <FaLaravel color="#37D892" size={30}/>}
                            {name === 'Docker' && <SiDocker color="#37D892" size={30}/>}
                            {name === 'Vercel' && <SiVercel color="#37D892" size={30}/>}
                            {name === 'Chakra UI' && <SiChakraui color="#37D892" size={30}/>}
                            {name === 'SWC' && <SiC color="#37D892" size={30}/>}
                            
                            <TextTech>{name}</TextTech>
                        </BoxTech>
                    );
                })}        
            </ContainerTech>
        </ContainerAbout>
    );
}

export default Technologies;
